export const calcData = [
  {
    id: 1,
    placeholder: "DD",
    label: "day",
    tag: "days",
  },
  {
    id: 2,
    placeholder: "MM",
    label: "month",
    tag: "months",
  },
  {
    id: 3,
    placeholder: "YYYY",
    label: "year",
    tag: "years",
  },
];
